module.exports = __webpack_public_path__ + "img/1.487e9ded.gif";